import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import RoomState from './context/rooms/RoomState';
import Navbar from "./components/Navbar";
import Carousel from "./components/Carousel";
import Rooms from './components/Rooms';
import Restaurant from './components/Restaurant';
import Footer from './components/Footer';
import Gallery from './components/Gallery';
import Roombooking from './components/Roombooking';
import Home from './components/Home';
import ReviewsList from './components/ReviewList';
import TermsAndConditions from './components/TermsAndConditions';
import RefundForm from './components/RefundForm';
import FloatingContactButton from './components/FloatingContactButton';
import ErrorBoundary from './components/ErrorBoundary';
import AdminLogin from './components/AdminLogin';
import AdminPanel from './components/AdminPanel';
import PrivacyPolicy from './components/PrivacyPolicy';
import KagbhusandiTrek from './components/KagbhusandiTal';
import SatopanthTrek from './components/SatopanthTal';

const LayoutWithConditionalNavbar = ({ children }) => {
  const location = useLocation();

  // Show navbar only on these routes
  const showNavbarRoutes = ["/restaurant", "/gallery", "/treks/kagbhusandi", "/treks/satopanth"];
  const showNavbar = showNavbarRoutes.includes(location.pathname);

  return (
    <>
      {showNavbar && <Navbar />}
      {children}
    </>
  );
};

const App = () => {
  return (
    <ErrorBoundary>
      <RoomState>
        <Router>
          <LayoutWithConditionalNavbar>
            <Routes>
              <Route exact path="/" element={
                <>
                  <Navbar />
                  <FloatingContactButton />
                  <Carousel />
                  <Home />
                  <Rooms />
                  <ReviewsList />
                  <Footer />
                </>
              } />
              <Route exact path="/restaurant" element={<Restaurant/>} />
              <Route exact path="/gallery" element={<Gallery/>} />
              <Route exact path="/booking" element={<Roombooking/>} />
              <Route exact path="/terms_and_conditions" element={<TermsAndConditions/>} />
              <Route exact path="/privacy_policy" element={<PrivacyPolicy/>} />
              <Route exact path="/refundForm" element={<RefundForm />}/>
              <Route exact path="/admin_login_page" element={<AdminLogin/>} />
              <Route exact path="/admin_panel" element={< AdminPanel/>}/>
              <Route exact path="/treks/kagbhusandi" element={<KagbhusandiTrek />} />
              <Route exact path="/treks/satopanth" element={<SatopanthTrek />} />
            </Routes>
          </LayoutWithConditionalNavbar>
        </Router>
      </RoomState>
    </ErrorBoundary>
  );
};

export default App;
